<template>
    <form class="g-3" @submit.prevent="submit">
        <div class="d-flex align-items-center justify-content-between">
            <label class="form-label m-0">{{ label }}</label>

            <div class="mx-3">
                <input
                    id="start_date"
                    name="start_date"
                    type="date"
                    class="form-control"
                    :class="{'is-invalid': startDateError.length}"
                    v-model="startDate"
                    :disabled="loading"
                    required
                />
                <span v-if="startDateError.length" class="invalid-feedback" v-text="startDateError"></span>
            </div>

            <button class="btn" :class="{'btn-alt-success': success, 'btn-alt-primary': ! success}" type="submit" :disabled="loading">
                {{ buttonText }}
            </button>
        </div>

        <div v-if="commandError.length" class="mt-3 text-end">
            <span class="text-danger" v-text="commandError"></span>
        </div>
    </form>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useFetch } from "@/components/useFetch";

const props = defineProps({
    route: String,
    command: String,
    label: String,
});

const defaultSubmitText = (props.submitText?.length) ? props.submitText : "Schedule";
const buttonText = ref(defaultSubmitText);
const loading = ref(false);
const success = ref(false);
const startDate = ref("");
const startDateError = ref("");
const commandError = ref("");

watch(
    () => startDate.value,
    () => {
        // restore button after submit
        buttonText.value = defaultSubmitText;
        success.value = false;
    },
);

const submit = async () => {
    startDateError.value = "";
    commandError.value = "";
    success.value = false;
    loading.value = true;
    buttonText.value = "Submitting...";

    const response = await useFetch(
        props.route,
        {
            method: "POST",
            body: {
                command: props.command,
                start_date: startDate.value,
            },
        },
    );

    if (response.ok) {
        success.value = true;
        buttonText.value = "Scheduled successfully";
        loading.value = false; // don't re enable the button just yet
        return;
    }

    if (response.status === 422) {
        const data = await response.json();
        startDateError.value = data?.errors?.start_date?.[0] ?? "";
        commandError.value = data?.errors?.command?.[0] ?? "";
    }

    buttonText.value = defaultSubmitText;
    loading.value = false;
};
</script>
